"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnsQueryGrid = exports.mapResultNode = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var TableColumnsByIdQueryGql_1 = require("../../queries/TableColumnsByIdQueryGql");
var TableColumnsDisplayGrid_1 = require("./TableColumnsDisplayGrid");
function selectConnectionListResult(resultData) {
    return resultData && resultData.tablesConnection &&
        resultData.tablesConnection.nodes[0] &&
        resultData.tablesConnection.nodes[0].columnsConnection;
}
function mapResultNode(node, resultData) {
    return __assign(__assign({}, node), { tags: data_catalog_shared_1.filterOutNullAndUndefined(node.tags.map(function (t) { return t.name; })), datasourceCount: node.downstreamDatasourcesConnection ? node.downstreamDatasourcesConnection.totalCount : null, sheetCount: node.downstreamSheetsConnection ? node.downstreamSheetsConnection.totalCount : null, tableId: resultData && resultData.tablesConnection && resultData.tablesConnection.nodes
            && resultData.tablesConnection.nodes[0] ? resultData.tablesConnection.nodes[0].id : '' });
}
exports.mapResultNode = mapResultNode;
function TableColumnsQueryGrid(props) {
    var publishedConnectionsLineageEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).publishedConnectionsLineageEnabled;
    var columnDQWs = React.useContext(data_catalog_shared_1.FeatureFlagsContext).columnDQWs;
    return (React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: TableColumnsByIdQueryGql_1.TableColumnsByIdQueryGql, partialQueryVariables: { tableId: props.tableId, orderBy: props.orderBy, publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled, columnDQWs: columnDQWs }, selectConnectionListResult: selectConnectionListResult, mapResultNode: mapResultNode, hackyUpdateNumber: props.hackyUpdateNumber }, function (_a) {
        var rowStore = _a.rowStore;
        return (React.createElement(TableColumnsDisplayGrid_1.TableColumnsDisplayGrid, { rowStore: rowStore, selectedKeys: props.selectedKeys, orderBy: props.orderBy, updateSelectionForKey: props.updateSelectionForKey, updateSortOrder: props.updateSortOrder, rowCount: props.rowCount }));
    }));
}
exports.TableColumnsQueryGrid = TableColumnsQueryGrid;
//# sourceMappingURL=TableColumnsQueryGrid.js.map